import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { User, UserService } from '../admins/user.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({ providedIn: 'root' })
export class ProfileResolver implements Resolve<User> {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly userService = inject(UserService);

  resolve(): Observable<User> {
    return this.oidcSecurityService.getUserData().pipe(switchMap((data) => this.userService.getUser(data.sub)));
  }
}
